import { createBrowserRouter, Navigate } from 'react-router-dom';
import { LoginPage } from './features/login/LoginPage';
import { ProtectedRoute } from './components/ProtectedRoute';
import { AppShell } from './components/AppShell/AppShell';
import { OverblikPage } from './features/overblik/OverblikPage';
import { MaanedsbudgetPage } from './features/budget/MaanedsbudgetPage';
import { YearTablePage } from './features/yearTable/YearTablePage';
import { MaalPage } from './features/maal/MaalPage';
import { KontiPage } from './features/konti/KontiPage';
import { GuidePage } from './features/guide/GuidePage';
import { GaeldPage } from './features/gaeld/GaeldPage';
import { PensionPage } from './features/pension/PensionPage';
import { IndstillingerPage } from './features/indstillinger/IndstillingerPage';
import { FamilierPage } from './features/familier/FamilierPage';
import { SetPasswordPage } from './features/opretAdgangskode/SetPasswordPage';

export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  { path: '/opret-adgangskode', element: <SetPasswordPage /> },
  {
    path: '/',
    element: (
      <ProtectedRoute>
        <AppShell />
      </ProtectedRoute>
    ),
    children: [
      { index: true, element: <Navigate to="/overblik" replace /> },
      { path: 'overblik', element: <OverblikPage /> },
      { path: 'budget', element: <MaanedsbudgetPage /> },
      { path: 'indtaegter', element: <YearTablePage kind="income" /> },
      { path: 'faste', element: <YearTablePage kind="fast" /> },
      { path: 'variable', element: <YearTablePage kind="variabel" /> },
      { path: 'maal', element: <MaalPage /> },
      { path: 'konti', element: <KontiPage /> },
      { path: 'guide', element: <GuidePage /> },
      { path: 'pension', element: <PensionPage /> },
      { path: 'gaeld', element: <GaeldPage /> },
      { path: 'familier', element: <FamilierPage /> },
      { path: 'indstillinger', element: <IndstillingerPage /> },
    ],
  },
  { path: '*', element: <Navigate to="/overblik" replace /> },
]);
